/**
 * @deprecated Do _NOT_ use `etiColors.confirmation`, prefer the `signal.positive` color tokens from `@etg/wings`.
 *
 * ```
 * import { vars } from '@etg/wings';
 *
 * const style = css`
 *   background-color: ${vars.colors.signal.positive.background};
 *   color: ${vars.colors.signal.positive.foreground};
 * `;
 * ```
 */
const confirmation = {
  focus: '#009700',
  solid: '#10a700',
  washed: '#aed8b2',
  light: '#f0fff1',
  opaque: '#10a60026'
};

/**
 * @deprecated Do _NOT_ use `etiColors.critical`, prefer the `signal.critical` color tokens from `@etg/wings`.
 *
 * ```
 * import { vars } from '@etg/wings';
 *
 * const style = css`
 *   background-color: ${vars.colors.signal.critical.background};
 *   color: ${vars.colors.signal.critical.foreground};
 * `;
 * ```
 */
const critical = {
  focus: '#c10f1d',
  solid: '#d00',
  washed: '#e2bcbc',
  light: '#ffe7e7',
  opaque: '#dc010026'
};

/**
 * @deprecated Do _NOT_ use `etiColors.info`, prefer the `signal.information` color tokens from `@etg/wings`.
 *
 * ```
 * import { vars } from '@etg/wings';
 *
 * const style = css`
 *   background-color: ${vars.colors.signal.information.background};
 *   color: ${vars.colors.signal.information.foreground};
 * `;
 * ```
 */
const info = {
  focus: '#2576C1',
  solid: '#3586d1',
  washed: '#bed2df',
  light: '#e9f5ff',
  opaque: '#3486d126'
};

/**
 * @deprecated Do _NOT_ use `etiColors.warning`, prefer the `signal.caution` color tokens from `@etg/wings`.
 *
 * ```
 * import { vars } from '@etg/wings';
 *
 * const style = css`
 *   background-color: ${vars.colors.signal.caution.background};
 *   color: ${vars.colors.signal.caution.foreground};
 * `;
 * ```
 */
const warning = {
  focus: '#df9d55',
  solid: '#ec8a0b',
  washed: '#e5d9aa',
  light: '#fcf3d8',
  opaque: '#ffb24e26'
};
const grayScale = {
  10: '#666',
  9: '#888',
  8: '#aaa',
  7: '#bbb',
  6: '#ccc',
  5: '#eee',
  4.5: '#e9e9e9',
  4: '#f0f0f0',
  3: '#f4f4f4',
  2: '#f8f8f8',
  1: '#fcfcfc'
};
const black = '#333';
const white = '#fff';
const lightBlue = '#f3fcff';

/**
 * @deprecated Do _NOT_ use `etiColors`, prefer the color tokens from `@etg/wings` that work across brands, and in dark mode.
 *
 * Also consider the current _use-case_/_intent_, so that the _correct_ color token is used in each situation.
 *
 * ```
 * import { vars } from '@etg/wings';
 *
 * const style = css`
 *   color: ${vars.colors.divider}
 * `;
 * ```
 */
export default {
  black,
  confirmation,
  critical,
  info,
  grayScale,
  warning,
  white,
  lightBlue
};
//# sourceMappingURL=index.js.map